var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import { Icon } from "../../UI";

import { Translate, t } from "../../I18N";
import Icons from "./Icons";

const titles = {
  defaultTitle:
  'This property has the same configuration as others with the same label and will be used together.',
  contentConflict:
  'Properties with the same label but different thesauri as content are not allowed.',
  relationConflict:
  'Relationship properties with the same label but different relationship types are not allowed.',
  typeConflict: 'Properties with the same label but incompatible types are not allowed.',
  inheritConflict:
  'Properties with the same label but incompatible inherited types are not allowed.'
};

const selectAndDateTranslationKeys = {
  select: 'Single select',
  multiselect: 'Multiple select',
  date: 'Single date',
  daterange: 'Single date range',
  multidate: 'Multiple date',
  multidaterange: 'Multiple date range'
};

















const inheritTypeToShow = (prop) =>
prop.inheritType ? prop.inheritType[0].toUpperCase() + prop.inheritType.slice(1) : '';

const invalidType = (prop) =>
prop.typeConflict || prop.relationConflict || prop.inheritConflict;

const typeToShow = (prop) =>
selectAndDateTranslationKeys[prop.type] || `property ${prop.type}`;

const title = (prop) => {
  if (prop.inheritConflict) {
    return titles.inheritConflict;
  }
  if (prop.relationConflict) {
    return titles.relationConflict;
  }
  if (prop.typeConflict) {
    return titles.typeConflict;
  }
  return '';
};

const contentTitle = (prop) =>
prop.contentConflict ? titles.contentConflict : '';

class SimilarProperty extends Component {
  render() {
    const { templateProperty } = this.props;
    const typeIcon = templateProperty.type;
    const invalidThesauri = templateProperty.contentConflict && templateProperty.thesaurusName;
    const inheritLabel = t('System', 'Inherit', null, false);
    return (/*#__PURE__*/
      _jsx("tr", { className: "property-atributes is-active" }, void 0, /*#__PURE__*/
      _jsx("td", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "file" }), " ", templateProperty.template
      ), /*#__PURE__*/
      _jsx("td", {
        className: invalidType(templateProperty) ? 'conflict' : '',
        title: title(templateProperty) }, void 0,

      invalidType(templateProperty) && /*#__PURE__*/_jsx(Icon, { icon: "exclamation-triangle" }), "\xA0", /*#__PURE__*/

      _jsx(Icon, { icon: Icons[typeIcon] || 'fa fa-font' }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, typeToShow(templateProperty)),
      templateProperty.relationTypeName && ` (${templateProperty.relationTypeName})`,
      inheritTypeToShow(templateProperty) &&
      ` (${inheritLabel}: ${inheritTypeToShow(templateProperty)})`
      ), /*#__PURE__*/
      _jsx("td", {
        className: templateProperty.contentConflict ? 'conflict' : '',
        title: contentTitle(templateProperty) }, void 0,

      invalidThesauri && /*#__PURE__*/_jsx(Icon, { icon: "exclamation-triangle" }),
      templateProperty.thesaurusName && /*#__PURE__*/_jsx(Icon, { icon: "book" }),
      templateProperty.thesaurusName
      )
      ));

  }
}


export { SimilarProperty };